import type { SpartanCustomizePreviewView } from '@/app/lcv/components/sections/spartan/products/customize/types';

export const isVehiclePreviewView = (view: SpartanCustomizePreviewView) =>
  view === 'front' || view === 'rear';

export const getPreviewObjectFit = (view: SpartanCustomizePreviewView) =>
  isVehiclePreviewView(view) ? 'contain' : 'cover';
